import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import english from '../../../assets/lang/english';
import { RootState } from '../../../redux/rootState';
import { setLoader } from '../../../redux/loaderSlice';
import { Empty } from '../../ScreenAddSmc/Utils/TypeSmc';
import {
  getForecastReportFailure, getJobScheduleListData, setNavigateFromScheduleTab, setSelectedTab,
} from '../UnscheduledJobs/addJob/redux/jobScheduleSlice';
import { JobsScheduleTableData } from '../UnscheduledJobs/utils/types';
import { FIRST_SELECTED_TAB, JobScheduleTableColumns } from '../UnscheduledJobs/utils/constants';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import { formatJobsData, formatScheduledJobsDataXl } from './utils/helper';
import { onGenerateInvoiceStart } from '../../../redux/masters/masterSlice';
import DataTable from '../../../Common/DataTable';
import ForecastReportModal from './ForecastReportModal';
import {
  resetPagination, setPageNumber, setPageSize, setSearchParam,
  setSortColumn,
  setSortDirection,
} from '../../taiReportingSystem/redux/sliceReportWorkspace';

function ScheduledJobs() {
  const navigate = useNavigate();
  const [openForecastModal, setOpenForecastModal] = useState(false);
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchQuery, setSearchQuery] = useState('');
  const [data, setData] = useState<JobsScheduleTableData[]>([]);
  const dispatch = useDispatch();
  const {
    pageNumber, pageSize, searchParam, sortColumn, sortDirection,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { historyStack } = useSelector((state:RootState) => state.masterDataReducer);
  const { jobScheduleData, isLoading } = useSelector((state: RootState) => state.jobScheduleReducer);

  const handleData = () => {
    const payload = {
      page: pageNumber,
      searchQuery: searchParam,
      rowsPerPage: pageSize,
      sortCol: sortColumn,
      sortDir: sortDirection,
      type: 1,
    };
    dispatch(getJobScheduleListData(payload));
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  useEffect(() => {
    handleData();
  }, [pageNumber, pageSize, searchParam, sortColumn, sortDirection]);

  const handleScheduleClick = (row: Empty) => {
    dispatch(setSelectedTab(FIRST_SELECTED_TAB));
    dispatch(setNavigateFromScheduleTab(true));
    navigate(`${row?.id}/${row?.jobId}`);
  };

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: formatScheduledJobsDataXl(jobScheduleData?.Data),
      },
      'JobsSchedule_list',
    );
  };

  const handleGenerateInvoice = (id: string) => {
    const payload = {
      type: 0,
      selectedIds: [id],
    };
    dispatch(onGenerateInvoiceStart(payload));
  };

  const handleCheckBoxWithKey = (id: string) => {
    const updatedData = data?.map((element: JobsScheduleTableData) => {
      if (element?.bidId === id) {
        return {
          ...element,
          isChecked: !element?.isChecked,
        };
      }
      return element;
    });
    setData(updatedData);
  };
  useEffect(() => {
    if (jobScheduleData?.Data) {
      setData(formatJobsData(jobScheduleData?.Data));
    }
  }, [jobScheduleData]);

  const handleButtonClick = () => {
    const jobIds: string[] = [];
    data?.forEach((element) => {
      if (element?.isChecked) {
        jobIds.push(element?.bidId);
      }
    });
    const payload = {
      type: 0,
      selectedIds: jobIds,
    };
    dispatch(onGenerateInvoiceStart(payload));
  };
  const jobSelected = useMemo(() => data?.every((ele) => !ele?.isChecked), [data]);

  useEffect(() => {
    if (historyStack) {
      const finderString = '/scheduled-jobs/';
      const last = historyStack[historyStack.length - 1];
      const sLast = historyStack[historyStack.length - 2];
      if (!(last?.includes(finderString) || (sLast?.includes(finderString) && last?.includes('/scheduled-jobs')))) {
        dispatch(resetPagination());
      }
    }
  }, [historyStack]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading={String(english.ScheduledJobs)} downloadExcel={downloadExcel} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<JobsScheduleTableData>
          data={data?.length > 0 ? data : []}
          columns={JobScheduleTableColumns}
          totalRecords={jobScheduleData?.TotalRecords}
          page={pageNumber}
          setPage={(e) => { dispatch(setPageNumber(e)); }}
          rowsPerPage={pageSize}
          setRowsPerPage={(e) => { dispatch(setPageSize(e)); }}
          searchQuery={searchParam}
          setSearchQuery={(e) => { dispatch(setSearchParam(e)); dispatch(setPageNumber(1)); }}
          sortCol={sortColumn}
          setSortCol={(e) => { dispatch(setSortColumn(e)); dispatch(setPageNumber(1)); }}
          sortDir={sortDirection}
          setSortDir={(e) => { dispatch(setSortDirection(e)); dispatch(setPageNumber(1)); }}
          handleData={handleData}
          handleScheduleClick={handleScheduleClick}
          handleGenerateInvoice={handleGenerateInvoice}
          checkBoxWithKey={['sn']}
          handleCheckBoxWithKey={handleCheckBoxWithKey}
          buttonText="Generate Invoice"
          forecastReportButtonName="Get Forecast Report"
          handleForecastButtonClick={() => { setOpenForecastModal(true); }}
          handleButtonClick={handleButtonClick}
          textButtonDisabled={jobSelected}
          handleDataFromComponent
        />
      </Grid>
      {openForecastModal
        && (
        <ForecastReportModal
          open={openForecastModal}
          handleClose={() => { setOpenForecastModal(false); dispatch(getForecastReportFailure()); }}
        />
        )}
    </Grid>
  );
}

export default ScheduledJobs;
